import React from 'react';

import RecentMaps from './recentmaps'

// State (recentMapsData / isLoading / error / refresh) is owned by dashboard.js
// so it survives tab toggles between Map / Frame / Style / Preview. The
// loading skeleton lives here so the layout matches what RecentMaps will
// render when the fetch completes.
const MobileMapLayout = ({
  isPortrait,
  setEnlargedImage,
  selectedFormat,
  handleSizeSelect,
  isUnlocking,
  setVoucher,
  setSelectedTab,
  compareFlashNonce = 0,
  recentMapsData,
  isLoadingRecentMaps,
  recentMapsError,
  refreshRecentMaps,
}) => {
  const maps = recentMapsData?.maps || [];
  const showSkeleton = isLoadingRecentMaps && maps.length === 0;

  return (
    <div className="w-full flex flex-col items-center space-y-4">
      <div className="relative w-full max-w-4xl mx-auto">
        {showSkeleton ? (
          <RecentMapsSkeleton />
        ) : recentMapsError ? (
          <div className="w-full aspect-[4/3] bg-gray-100 rounded-lg flex items-center justify-center text-red-500">
            {recentMapsError}
          </div>
        ) : (
          <RecentMaps
            recentMaps={maps}
            onEnlarge={setEnlargedImage}
            handleSizeSelect={handleSizeSelect}
            isUnlocking={isUnlocking}
            setVoucher={setVoucher}
            selectedFormat={selectedFormat}
            isPortrait={isPortrait}
            setSelectedTab={setSelectedTab}
            refreshRecentMaps={refreshRecentMaps}
            compareFlashNonce={compareFlashNonce}
          />
        )}
      </div>
    </div>
  );
};

// Mirrors the actual RecentMaps layout so the page doesn't visually jump
// when the fetch resolves: featured map area + 5-thumbnail row.
const RecentMapsSkeleton = () => (
  <div className="w-full max-w-4xl mx-auto space-y-4 animate-pulse">
    <div className="relative bg-gray-200 rounded-xl p-4 overflow-hidden flex justify-center items-center">
      <div className="w-full aspect-[4/3] max-h-[40vh] bg-gray-300 rounded-lg" />
    </div>
    <div className="flex justify-center">
      <div className="h-10 w-32 bg-gray-200 rounded-2xl" />
    </div>
    <div className="grid grid-cols-5 gap-2 md:gap-3">
      {[0, 1, 2, 3, 4].map((i) => (
        <div key={i} className="aspect-[4/3] bg-gray-200 rounded-lg" />
      ))}
    </div>
  </div>
);

export { MobileMapLayout }